<template>
  <div class="">
    <div
      v-if="loading"
      class="d-flex flex-row justify-center align-cneter"
      style="
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100 dvw;
        height: 100 dvh;
        z-index: 1000;
        background-color: rgba(0, 0, 0, 0.8);
      "
    >
      <v-progress-circular
        class="mt-16"
        indeterminate
        color="red"
        size="40"
      ></v-progress-circular>
    </div>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialog_subnow" width="800">
          <v-card dark>
            <v-card-title class="black white-text">
              Please Subscribe
            </v-card-title>

            <v-card-text>
              <h4>
                By entering and submitting your email below, you will receive an
                email notification each time there is a new press release.
              </h4>
              <template>
                <v-form v-model="valid" ref="formsub">
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="12">
                        <v-text-field
                          dark
                          v-model="emailsub"
                          :rules="emailRules"
                          label="E-mail"
                          required
                          :counter="60"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </template>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#2d3a57 " @click="subscribe_now">
                <v-icon color="white"> $send </v-icon> Submit
              </v-btn>
              <v-btn color="#2d3a57" @click="cancel_sub_now">
                <v-icon color="white"> $cancel </v-icon>
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--    <div v-show="show_media_reg" class="mt-5">
          <iframe
            id="idframe"
            v-show="show_media_reg"
            referrerpolicy="unsafe-url"
            ref="remote"
            :src="remoteUrl"
            :style="{ width: iframeWidth + 'px', border: 'none' }"
            height="600"
            style="border: 1px solid #ccc"
          ></iframe>
        </div> -->
      </div>
    </template>

    <div v-if="show_media_reg">
      <template>
        <v-form
          class="pa-2"
          ref="form_media_sub"
          v-model="valid2"
          lazy-validation
        >
          <h1 class="mb-2">Media Subscriber Registration</h1>
          <h3>
            Please fill out the following fields and press submit to register.
          </h3>
          <br />
          <v-text-field
            color="white"
            v-model="media_reg.email"
            :rules="emailRules"
            label="Email"
            required
            counter="120"
            maxlength="120"
          ></v-text-field>
          <v-text-field
            :rules="nameRules"
            color="white"
            v-model="media_reg.media_org"
            label="Media Organzation"
            required
            counter="120"
            maxlength="120"
          ></v-text-field>
          <v-text-field
            :rules="nameRulesUsr"
            color="white"
            v-model="media_reg.username"
            label="User Name"
            placeholder="At least 8 characters"
            required
            counter="16"
            maxlength="16"
          ></v-text-field>

          <v-text-field
            :rules="nameRules60"
            color="white"
            required
            class="mt-4 mb-4 pa-1"
            :append-icon="showeye ? `$eyeoff` : `$eye`"
            @click:append="toggle_eye"
            :type="showeye ? 'text' : 'password'"
            v-model="media_reg.password"
            label="Password"
            clearable
          ></v-text-field>
          <v-text-field
            :rules="nameRules"
            color="white"
            v-model="media_reg.question"
            label="Security Question"
            placeholder="favorite team, Favorite Food"
            required
            counter="120"
            maxlength="120"
          ></v-text-field>
          <v-text-field
            :rules="nameRules"
            color="white"
            v-model="media_reg.answer"
            label="Security Answer"
            placeholder="Answer Above Question"
            required
            counter="120"
            maxlength="120"
          ></v-text-field>

          <template>
            <div>
              <v-dialog v-model="show_imgfile_dialog" max-width="500px">
                <v-card
                  class="cmpbk_drk white--text"
                  style="border: 5px solid white !important"
                >
                  <!-- uplaod imag file -->
                  <v-card-title dark class="headline"
                    >Upload a Image File</v-card-title
                  >
                  <v-card-text dark>
                    <p class="white--text">
                      You must upload an image of your business card or other
                      professional credentials. <br />
                      To upload an image file, please select the save disk field
                      below and then use the upload button. The file name will
                      be prepended with a number on the server to preserve
                      uniqueness.
                    </p>
                    <v-row class="">
                      <v-col cols="12" md="12" lg="12" class="d-flex">
                        <v-file-input
                          prepend-icon="$save"
                          class="white-text"
                          v-if="showfileinput"
                          ref="fileInput"
                          id="fileimg"
                          show-size
                          accept=".png,.jpg, jpeg,"
                          label="File input"
                        ></v-file-input>
                        <v-btn
                          dark
                          class="white black--text ml-1 mt-1"
                          style="position: relative; top: 10px"
                          @click="uploadfileimg"
                          >Upload</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="rgb(31, 222, 176)"
                      text
                      @click="show_imgfile_dialog = false"
                    >
                      Close
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </template>
          <v-btn
            color="blue"
            class="mr-4 mb-2"
            @click="show_imgfile_dialog_now"
          >
            Upload Credential Required</v-btn
          >
          <v-row
            v-if="
              media_reg.img_filename != null && media_reg.img_filename != ''
            "
          >
            <v-col cols="6">
              <img
                style="max-width: 200px; height: auto"
                :src="'/upload/' + media_reg.img_filename"
                alt="cred image"
              />
            </v-col>
          </v-row>
          <hr />
          <br />
          <v-btn
            :disabled="!valid2"
            color="success"
            class="mr-4 mt-4"
            @click="submit_media_reg"
          >
            Submit
          </v-btn>

          <v-btn
            color="error"
            class="mr-4 mt-4"
            text
            @click="reset_show_media_reg"
          >
            Cancel</v-btn
          >
        </v-form>
      </template>
    </div>
    <!-- show_forgot -->
    <div v-if="show_forgot">
      <h1 class="mb-2 pa-2">Media Subscriber Recovery</h1>
      <h3 class="pa-2">Enter your Username to begin.</h3>
      <v-form
        class="pa-2"
        ref="form_forgot_user"
        v-model="valid_forgot"
        lazy-validation
      >
        <v-text-field
          :rules="nameRulesUsr"
          color="white"
          v-model="recovery.username"
          label="User Name"
          placeholder="At least 8 characters"
          required
          counter="16"
          maxlength="16"
        ></v-text-field>

        <v-btn
          :disabled="!valid_forgot"
          color="success"
          class="mr-4 mt-4"
          @click="submit_username"
        >
          Submit
        </v-btn>

        <v-btn color="error" class="mr-4 mt-4" text @click="reset_forgot">
          Cancel</v-btn
        >
      </v-form>
    </div>
    <!-- show_question -->
    <div v-if="show_question">
      <h1 class="mb-2 pa-2">Media Subscriber Recovery</h1>
      <h3 class="pa-2">Answer your security question.</h3>
      <v-form
        class="pa-2"
        ref="form_question"
        v-model="valid_question"
        lazy-validation
      >
        <h4>Question: "{{ recovery.question }}""</h4>
        <v-text-field
          :rules="nameRules"
          color="white"
          v-model="recovery.answer"
          label="Answer"
          required
          counter="120"
          maxlength="120"
        ></v-text-field>

        <v-btn
          :disabled="!valid_question"
          color="success"
          class="mr-4 mt-4"
          @click="submit_answer"
        >
          Submit
        </v-btn>

        <v-btn color="error" class="mr-4 mt-4" text @click="reset_forgot">
          Cancel</v-btn
        >
      </v-form>
    </div>
    <!-- show_set_password -->
    <div v-if="show_set_password">
      <h1 class="mb-2 pa-2">Media Subscriber Recovery</h1>
      <h3 class="pa-2">Please Set your new password.</h3>
      <v-form
        class="pa-2"
        ref="form_set_password"
        v-model="valid_password"
        lazy-validation
      >
        <v-text-field
          :rules="nameRules60"
          color="white"
          required
          class="mt-4 mb-4 pa-1"
          :append-icon="showeye ? `$eyeoff` : `$eye`"
          @click:append="toggle_eye"
          :type="showeye ? 'text' : 'password'"
          v-model="recovery.new_password"
          label="Password"
          clearable
        ></v-text-field>

        <v-btn
          :disabled="!valid_password"
          color="success"
          class="mr-4 mt-4"
          @click="submit_password"
        >
          Submit
        </v-btn>

        <v-btn color="error" class="mr-4 mt-4" text @click="reset_forgot">
          Cancel</v-btn
        >
      </v-form>
    </div>
    <!-- LOGIN-->
    <div v-if="show_media_login">
      <h1 class="mb-2 pa-2">Media Subscriber Login</h1>
      <h3 class="pa-2">
        Please fill out the following fields and press submit to login.
      </h3>
      <v-form
        class="pa-2"
        ref="form_media_login"
        v-model="valid3"
        lazy-validation
      >
        <v-text-field
          :rules="nameRulesUsr"
          color="white"
          v-model="media_login.username"
          label="User Name"
          placeholder="At least 8 characters"
          required
          counter="16"
          maxlength="16"
        ></v-text-field>

        <v-text-field
          :rules="nameRules60"
          color="white"
          required
          class="mt-4 mb-4 pa-1"
          :append-icon="showeye ? `$eyeoff` : `$eye`"
          @click:append="toggle_eye"
          :type="showeye ? 'text' : 'password'"
          v-model="media_login.password"
          label="Password"
          clearable
        ></v-text-field>
        <v-btn
          :disabled="!valid3"
          color="success"
          class="mr-4 mt-4"
          @click="submit_media_login"
        >
          Submit
        </v-btn>
        <v-btn color="success" class="mr-4 mt-4" @click="show_forgot_now">
          Forgot Password?
        </v-btn>

        <v-btn color="error" class="mr-4 mt-4" text @click="reset_media_login">
          Cancel</v-btn
        >
      </v-form>
    </div>
    <v-main v-show="show_main_page == true">
      <v-container class="" id="home-container">
        <!-- <div id="hero" class="background-container-img"></div> -->
        <div
          id="title_layout"
          style="position: relative; top: 0; width: 100%; margin: 0; padding: 0"
        >
          <v-card color="#2d3a57" class="white--text" elevation="3 ">
            <v-card-text class="white--text">
              <div class="d-flex justify-space-between">
                <img src="../images/gold-badge-48px.png" />
                <v-spacer></v-spacer>
                <h2 style="position: relative; top: 10px">
                  Reno Police Department
                </h2>
                <v-spacer></v-spacer>
                <div
                  style="
                    position: relative;
                    top: 10px;
                    font-weight: 600;
                    z-index: 200;
                  "
                >
                  <a href="#" @click="show_media_login_now">Media Login</a>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </div>
        <div
          id="sub_title_layout"
          style="
            position: relative;
            top: 15%;
            width: 35%;
            margin: 0;
            padding: 0;
            margin-left: auto;
            margin-right: auto;
          "
        ></div>

        <div
          id="publicinfocont"
          style="
            width: 100%;

            z-index: 100;
            position: relative;
          "
          class="d-flex justify-center"
        >
          <h1
            style="
              font-size: 28px;
              color: white;
              text-shadow: 1px 1px 2px rgba(0, 0, 0, 1);
            "
          >
            Office of Public Information
          </h1>
        </div>
        <!-- <div id="gradeint" class="hero_bg-video-overlay"></div> -->
        <h3
          id="listofpress"
          style="
            font-size: 22px;
            text-shadow: 2px 2px 3px rgba(0, 0, 0, 1);
            z-index: 100;
            position: relative;
          "
          class="ml-2 pa-3 mb-5"
        >
          List of Press Releases
        </h3>

        <div id="sub_title_layout">
          <v-card
            v-if="show_text_card"
            style="background-color: #2d3a57"
            class="white--text ml-2 pa-3 mb-5 rounded_corners"
          >
            <v-card-text class="white--text"
              ><h3>
                The Reno Police Department values keeping the community informed
                about the operation of your community's police. One of the ways
                to accomplish this is by regularly maintaining the news media,
                and thereby the public, informed of events involving the RPD and
                its personnel. Below is a list of past press releases.
                <br /><br />
                Contact our Public Information Officer for any media inquiries
                <a href="mailto:johnsonchris@reno.gov" target="_blank">here</a>.
                <br /><br />
                Submit public information requests
                <a href="https://reno.streamlinegov.us/" target="_blank">here</a
                >.
              </h3></v-card-text
            >
            <v-card-actions>
              <v-btn
                @click="citizen_sub"
                color="yellow"
                class="black--text"
                style="width: 100%"
                >Subscribe Here</v-btn
              >
            </v-card-actions>
          </v-card>
          <!-- <v-btn
            @click="test_media"
            color="yellow"
            class="black--text"
            style="width: 100%"
            >Test Media</v-btn
          > -->
          <div
            color="#2d3a57"
            v-for="year in lst_releases"
            :key="year.news_releaseId"
            style="z-index: 100; position: relative"
          >
            <h1 class="txtshdw mt-3 bkall">
              {{ year.year }}
            </h1>
            <div v-for="month in year.vm_months" :key="month.month">
              <h2 class="txtshdw bkall">
                {{ month.month }}
              </h2>
              <v-card
                class="mb-3 rounded_corners bkall"
                :style="{
                  backgroundColor: adate.media_only ? 'darkblue' : '#2d3a57',
                }"
                v-for="adate in month.lstrels"
                :key="adate.news_releaseId"
              >
                <v-card-title
                  >{{ adate.news_date | usdate }}
                  <span v-if="adate.media_only"
                    >&nbsp;&nbsp;Media Only</span
                  ></v-card-title
                >
                <v-card-text
                  ><a
                    class="subtitle-1"
                    href="#"
                    @click="goto_viewone(adate.news_releaseId)"
                  >
                    {{ adate.release_title }}</a
                  ></v-card-text
                >
              </v-card>
            </div>
          </div>
        </div>
      </v-container>
    </v-main>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */
strong {
  font-weight: 800;
  color: cornflowerblue;
}
.rounded_corners {
  border-radius: 31px 31px 31px 31px;
  -webkit-border-radius: 31px 31px 31px 31px;
  -moz-border-radius: 31px 31px 31px 31px;
}

@media (min-width: 0px) {
  // .hero_bg-video-overlay {
  //   background-image: linear-gradient(180deg, #0003 80%, black);
  //   position: absolute;
  //   height: 80dvh;
  //   z-index: 50;
  //   inset: 0%;
  //   top: 0;
  // }
  .hero_bg-video-overlay {
    position: absolute;
    height: 80dvh;
    z-index: 50;
    inset: 0%;
    top: 0;
  }

  .bkall {
    background-color: #445885;
  }

  .txtshdw {
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 1);
  }
  #vapp,
  #main {
    background-color: black !important;
  }
  a {
    color: #72b2ff !important;
  }
  #listofpress {
    top: 1px;
  }
  #sub_title_layout {
    top: 1px;
    position: relative;
    z-index: 100;
    width: 98%;
    margin: auto;
    padding: 0;
  }
  #home-container {
    max-width: 768px;
    width: 100%;
    padding: 0 !important;
    margin: 0 !important;
  }
  // #hero {
  //  width: 100% svw;
  //   height: 100% svh;
  // }
  .background-container-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 80dvh; /* One-third of the viewport height */
    background-image: url(../images/heroarch3.png); /* Replace with your image URL */
    background-size: auto; /* Cover the entire container */
    background-position: center; /* Center the background image */
    background-repeat: no-repeat; /* Prevent repeating */
    background-position-y: 77px;
  }
  #home-container {
    width: 100%;
    height: auto;
  }

  .alice {
    color: aliceblue;
  }

  .log-header .v-btn {
    background-color: #fc5c5c;
  }

  .section1 h1 {
    text-shadow: 2px 2px 4px #000000;
  }

  .training-table .v-data-table {
    border: 1px solid darkslateblue;
  }

  .training-table .v-btn__content {
    visibility: hidden !important;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .section1 {
    justify-content: center;
    width: 100%;
  }
  #listofpress {
    top: 1px;
  }
  #sub_title_layout {
    top: 1px;
    position: relative;
    z-index: 100;
    width: 98%;
    margin: auto;
    padding: 0;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
  .section1 {
    justify-content: flex-start;
    width: 100%;
  }
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import banner from "./banner.vue";

export default {
  name: "Home",
  components: {
    banner,
  },
  mixins: [bus_common],
  data() {
    return {
      lst_badge_images: [],
      recovery: {
        news_media_subscribersId: 0,
        username: "",
        question: "",
        answer: "",
        new_password: "",
      },

      media_login: {
        username: "",
        password: "",
      },
      valid3: true,
      show_set_password: false,
      show_question: false,
      show_forgot: false,
      show_main_page: true,
      show_media_login: false,
      show_imgfile_dialog: false,
      showfileinput: true,
      showeye: false,
      media_reg: {
        email: "",
        media_org: "",
        username: "",
        password: "",
        question: "fsgfdgd",
        answer: "",
        img_filename: "",
      },
      select: null,
      items: ["Item 1", "Item 2", "Item 3", "Item 4"],
      checkbox: false,
      iframeWidth: 0,
      remoteUrl: "https://citizen.rpdportal.org/",
      emailsub: "",
      show_media_reg: false,
      show_text_card: false,
      show_media_only: false,
      valid: false,
      valid2: true,
      valid_forgot: true,
      valid_question: true,
      valid_password: true,
      password_in: "",
      firstname: "",
      lastname: "",
      nameRulesUsr: [
        (v) => !!v || "Field is required",
        (v) => v.length >= 8 || "Field must be at least 8 characters",
      ],
      nameRules60: [
        (v) => !!v || "Field is required",
        (v) => v.length <= 60 || "Field must be less than 60 characters",
      ],
      nameRules: [
        (v) => !!v || "Field is required",
        (v) => v.length <= 120 || "Field must be less than 120 characters",
      ],
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      dialog: true,
      dialog_subnow: false,
      lst_releases: [],
      lst_year: [],
      lst_year_month: [],
    };
  },
  watch: {
    "$store.state.user": function () {
      //keep this
      let self = this;
      this.show_media_only = true;
      this.init();
    },
  },
  computed: {
    loading: function () {
      console.log(
        "this.$store.state.loader_visible: " + this.$store.state.loader_visible
      );
      return this.$store.state.loader_visible;
    },
  },
  filters: {
    ifnone(value) {
      if (value == "01/01/1900") {
        return "None";
      } else {
        return value;
      }
    },
    ifnonestr(value) {
      if (value == "" || value == null) {
        return "None";
      } else {
        return value;
      }
    },
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    usdate(datestr) {
      const date = new Date(datestr);
      const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-indexed
      const day = date.getDate().toString().padStart(2, "0");
      const year = date.getFullYear();

      return `${month}/${day}/${year}`;
    },
  },
  methods: {
    reset_forgot() {
      this.show_main_page = false;

      this.show_forgot = false;
      this.show_question = false;
      this.show_set_password = false;
      this.show_media_login = true;
      setTimeout(() => {
        this.$refs.form_media_login.reset();
      }, 500);
    },
    cancel_sub_now() {
      this.dialog_subnow = false;
    },
    cancel_media_reg() {
      window.location.href = "https://newsroom.renopd.com/";
    },
    //submit_password
    submit_password() {
      console.log("submit_password");

      this.show_loader(true);
      let formIn = {};

      if (this.$refs.form_set_password.validate() == false) {
        this.swall_it(
          "Submit Password Status",
          "Please address the red fields as error(s) exist.",
          "warning",
          null,
          null
        );
        return true;
      }
      if (this.recovery.new_password.length < 8) {
        this.swall_it(
          "Submit Password Status",
          "Password must be at least 8 characters.",
          "warning",
          null,
          null
        );
        return true;
      }
      //date is in sql format in local var
      formIn.new_password = this.recovery.new_password;
      formIn.news_media_subscribersId = this.recovery.news_media_subscribersId;

      formIn.apiname = "submit_password";

      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          if (data == "fail") {
            this.swall_it(
              "Error Saving",
              "Unknown error.",
              "warning",
              null,
              null
            );
            return true;
          }
          this.show_set_password = false;
          this.show_media_login = true;
          setTimeout(() => {
            this.$refs.form_media_login.reset();
          }, 500);

          this.swall_it(
            "Submit Password Status",
            "Success",
            "success",
            null,
            null
          );
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    submit_answer() {
      console.log("submit_answer");

      this.show_loader(true);
      let formIn = {};

      if (this.$refs.form_question.validate() == false) {
        this.swall_it(
          "Submit Answer Status",
          "Please address the red fields as error(s) exist.",
          "warning",
          null,
          null
        );
        return true;
      }
      //date is in sql format in local var
      formIn.answer = this.recovery.answer;
      formIn.news_media_subscribersId = this.recovery.news_media_subscribersId;

      formIn.apiname = "submit_answer";

      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          if (data == "fail") {
            this.swall_it(
              "Error Saving",
              "Answer not correct.",
              "warning",
              null,
              null
            );
            return true;
          }

          this.show_question = false;
          this.show_set_password = true;
          setTimeout(() => {
            this.$refs.form_set_password.reset();
          }, 500);

          this.swall_it(
            "Submit Answer Status",
            "Success",
            "success",
            null,
            null
          );
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    submit_username() {
      console.log("submit_username");

      this.show_loader(true);
      let formIn = {};

      if (this.$refs.form_forgot_user.validate() == false) {
        this.swall_it(
          "Submit Username Status",
          "Please address the red fields as error(s) exist.",
          "warning",
          null,
          null
        );
        return true;
      }
      //date is in sql format in local var

      formIn.username = this.recovery.username;

      formIn.apiname = "submit_username";

      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          if (data == "fail") {
            this.swall_it(
              "Error Saving",
              "Username not found.",
              "warning",
              null,
              null
            );
            return true;
          }
          this.recovery.question = data.question;
          this.recovery.news_media_subscribersId =
            data.news_media_subscribersId;
          this.show_forgot = false;
          this.show_question = true;
          setTimeout(() => {
            this.$refs.form_question.reset();
          }, 500);

          this.swall_it(
            "Submit Username Status",
            "Success",
            "success",
            null,
            null
          );
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    //show_media_login
    show_forgot_now() {
      this.show_main_page = false;
      this.show_media_login = false;
      this.show_forgot = true;
    },
    show_media_login_now() {
      this.show_main_page = false;
      this.show_media_login = true;
    },
    //show_imgfile_dialog_now
    show_imgfile_dialog_now() {
      this.show_imgfile_dialog = true;
    },
    //uploadfileimg
    uploadfileimg() {
      console.log("empty: " + document.getElementById("fileimg").files[0]);
      if (document.getElementById("fileimg").files[0] == undefined) {
        this.swall_it(
          "Upload Status",
          "Please select a file before uploading.",
          "warning",
          null,
          null
        );
        return true;
      }
      console.log("file email: " + this.$store.state.user.email);
      const formData = new FormData();
      formData.append("file", document.getElementById("fileimg").files[0]);
      formData.append("id", this.media_reg.news_media_subscribersId);
      formData.append("email", this.$store.state.user.email);

      var self = this;
      this.showfileinput = false;

      this.$store
        .dispatch("uploadfileimg", formData)
        .then((data) => {
          if (data.indexOf("error") > -1) {
            self.swall_it(
              "Upload Status",
              "Uknown Error file not saved.",
              "error",
              null,
              null
            );
            return true;
          }

          console.log("upload file");
          self.showfileinput = true;
          self.media_reg.img_filename = data;
          self.swall_it(
            "Upload Status",
            data + " uploaded",
            "success",
            null,
            null
          );
          self.getInitRecent();
          self.show_imgfile_dialog = false;
        })
        .catch((msg) => {
          this.show_loader(false);
          self.mrbreakpoint("err");
          console.log(msg);
          // this.swall_it("Error Fetching Expended", msg, "error", null, null);
        });
    },
    toggle_eye() {
      this.showeye = !this.showeye;
    },
    reset_show_media_reg() {
      this.$refs.form_media_sub.reset;
      this.show_media_reg = false;
      window.location.href = "https://newsroom.renopd.com/";
    },
    reset_media_login() {
      this.$refs.form_media_login.reset;
      this.show_main_page = true;
      this.show_media_login = false;
    },
    submit_media_login() {
      console.log("submit_media_login");

      this.show_loader(true);
      let formIn = {};

      if (this.$refs.form_media_login.validate() == false) {
        this.swall_it(
          "Submit Login Status",
          "Please address the red fields as error(s) exist.",
          "warning",
          null,
          null
        );
        return true;
      }
      //date is in sql format in local var

      formIn.media_reg = this.mno(this.media_login);

      formIn.apiname = "submit_media_login";

      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          if (data == "fail") {
            this.swall_it(
              "Error Saving",
              "Username or Password did not match.",
              "warning",
              null,
              null
            );
            return true;
          }

          self.$refs.form_media_login.reset();
          self.emailsub = "";
          self.show_main_page = true;
          self.show_media_login = false;
          let user = { email: data.email, media_org: data.media_org };
          self.$store.commit("setUser", user);
          this.swall_it("Media Login Status", "Success", "success", null, null);
          setTimeout(() => {
            self.getInitRecent();
          }, 500);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    submit_media_reg() {
      console.log("submit_media_reg");

      this.show_loader(true);
      let formIn = {};
      if (
        this.media_reg.img_filename == null ||
        this.media_reg.img_filename == ""
      ) {
        this.swall_it(
          "Submit Registration Status",
          "Credential image must be uploaded.",
          "warning",
          null,
          null
        );
        return true;
      }
      if (this.$refs.form_media_sub.validate() == false) {
        this.swall_it(
          "Submit Registration Status",
          "Please address the red fields as error(s) exist.",
          "warning",
          null,
          null
        );
        return true;
      }
      if (this.media_reg.password.length <= 7) {
        this.swall_it(
          "Submit Registration Status",
          "Password msut be at least 8 characters.",
          "warning",
          null,
          null
        );
        return true;
      }
      //date is in sql format in local var
      formIn.token = this.$store.state.user.token;
      formIn.email = this.$store.state.user.email;
      formIn.media_reg = this.mno(this.media_reg);

      formIn.apiname = "submit_media_reg";

      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          if (data == "dupe") {
            this.swall_it(
              "Error Saving",
              "This Username is already subscribed. Please choose another.",
              "warning",
              null,
              null
            );
            return true;
          }
          self.$refs.form_media_sub.reset();
          self.emailsub = "";
          self.show_media_reg = false;
          self.show_media_login = true;

          this.swall_it(
            "Media Subscribe Status",
            "Success",
            "success",
            null,
            null
          );
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    subscribe_now() {
      console.log("subscribe_now");

      this.show_loader(true);
      let formIn = {};
      if (this.emailsub == "") {
        this.swall_it(
          "Subscribe Status",
          "Email cannot be blank.",
          "warning",
          null,
          null
        );
        return true;
      }
      //date is in sql format in local var
      formIn.token = this.$store.state.user.token;
      formIn.email = this.$store.state.user.email;
      formIn.emailsub = this.emailsub;

      formIn.apiname = "subscribe_now";

      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          if (data == "dupe") {
            this.swall_it(
              "Error Saving",
              "This email is already subscribed.",
              "warning",
              null,
              null
            );
            return true;
          }
          self.$refs.formsub.reset();
          self.emailsub = "";
          self.show_media_reg = false;
          self.dialog_subnow = false;
          this.swall_it("Subscribe Status", "Success", "success", null, null);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    citizen_sub() {
      this.dialog_subnow = true;
    },
    goto_viewone(news_releaseId) {
      // this.mrbreakpoint("viewon");
      if (news_releaseId == undefined) {
        this.swall_it(
          "Viewing One Release",
          "Not ready. Please try again.",
          "warning",
          null,
          null
        );
        return true;
      }
      let self = this;
      this.$router
        .push({
          name: "viewone",
          params: { id: news_releaseId },
        })
        .catch((err) => {
          this.$router.push({
            name: "viewone",
            params: { id: news_releaseId },
          });
          // this.swall_it(
          //   "Viewing One Release",
          //   "Not ready. Please try again.",
          //   "warning",
          //   null,
          //   null
          // );

          //throw err;
        });
    },
    login_now() {
      console.log("login_now");

      this.show_loader(true);
      let formIn = {};
      //date is in sql format in local var

      formIn.email = this.email;
      formIn.password_in = this.password_in;

      formIn.apiname = "login_now";

      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.dialog = false;
          self.show_loader(false);
          let user = { email: data.email, media_org: data.media_org };
          self.$store.commit("setUser", user);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it(
            "Error Logging In",
            "Your email or password is incorrect.",
            "warning",
            null,
            null
          );
        });
    },
    filterDistinctByProperty(array, property) {
      const seen = new Set();
      return array.filter((item) => {
        const value = item[property];
        if (seen.has(value)) {
          return false;
        } else {
          seen.add(value);
          return true;
        }
      });
    },
    filtered_years() {
      let self = this;
      this.lst_year = this.filterDistinctByProperty(this.lst_releases, "year");
      this.lst_year.forEach((ayear) => {
        let months = self.filterDistinctByProperty(self.lst_year, "month_name");

        months.forEach((amonth) => {
          //checkl that the lst of releases has one item for month year
          self.mrbreakpoint();
          const monthsyears = self.lst_releases.filter(
            (item) =>
              item.year === ayear.year && item.month_name === amonth.month_name
          );
          console.log(
            "monthsyears: ",
            monthsyears[0].year,
            monthsyears[0].month_name
          );
          if (monthsyears.length > 0 && monthsyears != undefined) {
            self.lst_year_month.push({
              year: ayear.year,
              month: amonth.month_name,
            });
          }
        });
      });
    },
    filtered_months(year) {
      let months4year = this.lst_year_month.filter(
        (item) => item.year === year
      );
      months4year.forEach((item) => {
        // console.log("months4year", year, item.year, item.month);
      });
      return months4year;
    },
    filtered_dates(year, month) {
      console.log("filtered_dates called: ", year, month);
      let alldates = this.lst_releases.filter(
        (item) => item.year === year && item.month_name == month
      );
      alldates.forEach((element) => {
        // console.log(year, month, "alldate: " + element.news_date);
      });
      return alldates;
    },
    sortByPropertiesDescending(
      array,
      primaryProperty,
      secondaryProperty,
      tertiaryProperty
    ) {
      array.sort((a, b) => {
        if (a[primaryProperty] > b[primaryProperty]) {
          return -1;
        } else if (a[primaryProperty] < b[primaryProperty]) {
          return 1;
        } else {
          if (a[secondaryProperty] > b[secondaryProperty]) {
            return -1;
          } else if (a[secondaryProperty] < b[secondaryProperty]) {
            return 1;
          } else {
            if (a[tertiaryProperty] > b[tertiaryProperty]) {
              return -1;
            } else if (a[tertiaryProperty] < b[tertiaryProperty]) {
              return 1;
            } else {
              return 0;
            }
          }
        }
      });
    },
    getFirst200Characters: function (inputString) {
      // Check if the input string is less than or equal to 60 characters

      if (inputString.length <= 200) {
        return inputString;
      }
      // Return the first 30 characters
      return inputString.substring(0, 200);
    },
    /* sendRequest(rowData) {
      console.log(rowData);
    }, */
    sendRequest() {
      alert("This button does nothing yet.");
    },
    message1() {
      alert("This button does nothing yet.");
    },

    message2() {
      alert("when clicked this ");
    },
    getInitRecent() {
      console.log("getInitRecent: " + this.$store.state.user.email);

      this.show_loader(true);
      let formIn = {};
      //date is in sql format in local var
      formIn.token = this.$store.state.user.token;
      formIn.email = this.$store.state.user.email;
      formIn.apiname = "getInitRecent";
      let b_media = this.$store.state.user.email != "";
      console.log("b_media: " + b_media);
      formIn.show_media_only = b_media;
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_text_card = true;
          self.lst_releases = self.mno(data);
          // self.sortByPropertiesDescending(
          //   self.lst_releases,
          //   "year",
          //   "month_num",
          //   "news_date"
          // );

          for (let index = 0; index < self.lst_releases.length; index++) {
            const element = self.lst_releases[index];
            element.s_date = self.format_date_us(element.s_date);
            element.s_CreateDate = self.format_date_us(element.s_CreateDate);
            element.news_date = self.format_date_us(element.news_date);
            element.release_date = self.format_date_us(element.release_date);
            element.website_date = self.format_date_us(element.website_date);
            console.log("news_date: " + element.news_date);
            // element.html_release_text = self.getFirst200Characters(
            //   element.release_text
            // );
          }
          //this.filtered_years();
          setTimeout(() => {
            this.show_loader(false);
          }, 1000);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    //test_media
    test_media() {
      console.log("valid_media_email: gzant");

      this.show_loader(true);
      let formIn = {};
      //date is in sql format in local var
      formIn.token = this.$store.state.user.token;
      formIn.email = "gzantmolt@gmail.com";
      formIn.apiname = "valid_media_email";

      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.mrbreakpoint("valid media");
          console.log("data.msg valid_media_email: " + data.msg);
          if (data.msg == "true") {
            return true;
          } else {
            return false;
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it(
            "Error valid_media_email",
            "uknown error",
            "error",
            null,
            null
          );
        });
    },
    //valid_media_email
    valid_media_email(email, callback) {
      console.log("valid_media_email: " + email);

      this.show_loader(true);
      let formIn = {};
      //date is in sql format in local var
      formIn.token = this.$store.state.user.token;
      formIn.email = email;
      formIn.apiname = "valid_media_email";

      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.mrbreakpoint("valid media");
          console.log("data.msg valid_media_email: " + data.msg);
          if (data.msg == "true") {
            console.log(" valid_media_email returns true ");
            callback(true);
            //  return true;
          } else {
            console.log(" valid_media_email returns false ");
            callback(false);
            //return false;
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it(
            "Error valid_media_email",
            "uknown error",
            "error",
            null,
            null
          );
        });
    },
    media_reg_on(isv) {
      console.log("media_reg_on");

      this.show_loader(true);
      let formIn = {};
      formIn.isv = isv;
      formIn.apiname = "media_reg_on";
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          console.log("medai sub:", data.email, data.media_org);
          this.media_reg = this.mno(data);

          this.show_main_page = false;
          this.show_media_reg = true;
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it(
            "Error media_reg_on",
            "uknown error",
            "error",
            null,
            null
          );
        });
    },
    //get_badge_images
    get_badge_images() {
      console.log("get_badge_images");

      this.show_loader(true);
      let formIn = {};
      //date is in sql format in local var
      formIn.token = this.$store.state.user.token;
      formIn.email = this.$store.state.user.email;
      formIn.apiname = "get_badge_images";
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.show_loader(false);
          self.lst_badge_images = self.mno(data);
          self.lst_badge_images.forEach((element) => {
            element.url = "../img/" + element.filename;
          });
          this.$store.commit("set_lst_badge_images", self.lst_badge_images);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    init(self) {
      this.getInitRecent();
      this.get_badge_images();
      setTimeout(() => {
        const query = this.$route.query;
        if (Object.keys(query).length > 0) {
          const query = this.$route.query;
          console.log("query str exists");
          const isv = query.i;
          console.log("i: " + isv);
          if (isv != null) {
            self.media_reg_on(isv);
          }
          this.show_loader(true);
        }
      }, 500);
    },
  },
  mounted() {
    this.show_loader(true);

    var self = this;
    this.$nextTick(() => {
      this.init(self);
    });
  },
};
</script>
